const init = (callback) => {
	try {
		if (window.google_auth2) {
			if (callback) callback();
			return;
		}

		throw 'error';
	} catch (error) {
		window.onGoogleLibraryLoad = () => {
			window.google_auth2 = google.accounts.oauth2.initTokenClient({
				// client_id: '906194913017-m05edkttb12v53qc1s0tmjg3jhuq6fp8.apps.googleusercontent.com',
				client_id: '868173029764-209c7p27dpmfhdmmbu4psru92u3gatig.apps.googleusercontent.com',
				scope: 'https://www.googleapis.com/auth/userinfo.email',
				callback: (tokenResponse) => {
					if (callback) callback(tokenResponse);
				}
			});

		}

		var installGoogleSdkScript = (d, s, id) => {
			if (d.getElementById(id)) return

			let fjs = d.getElementsByTagName(s)[0]
			let js = d.createElement(s)
			js.id = id
			js.src = 'https://accounts.google.com/gsi/client'
			fjs.parentNode.insertBefore(js, fjs)
		}

		installGoogleSdkScript(document, 'script', 'google-jssdk')
	}
}

export default init;


// WEBPACK FOOTER //
// resources/modules/components/login/google-sdk.js